import classNames from 'classnames';
import React from 'react';
import type { Merge } from 'types/utility';
import styles from './Tooltip.module.scss';

export type TooltipPosition =
  | 'top'
  | 'top-left'
  | 'top-right'
  | 'right'
  | 'bottom'
  | 'bottom-left'
  | 'bottom-right'
  | 'left';

interface TooltipProps {
  children: React.ReactNode;
  title?: string | null;
  position?: TooltipPosition;
}

type DivSpanProps = Omit<React.HTMLProps<HTMLDivElement | HTMLSpanElement>, 'ref' | 'tooltip'>;
type Props = Merge<DivSpanProps, TooltipProps>;

const Tooltip: React.FC<Props> = props => {
  // no title? Pass it through:
  if (!props.title && !props.className) {
    return <>{props.children}</>;
  } else if (!props.title) {
    const { position, children, title, ...rest } = props;
    return <span {...rest}>{props.children}</span>;
  }

  // Allow unspecified attributes to be passed to child as 'rest'
  const { title, className, position, children, ...rest } = props;

  // hint--no-animate
  const containerClass = classNames(
    styles.container,
    'hint--rounded',
    `hint--${position || 'top'}`,
    className
  );

  return (
    <div {...rest} title="" className={containerClass} data-hint={title}>
      {children}
    </div>
  );
};

export default Tooltip;
